import type { Fetcher } from "react-query-kit";
import { createQuery } from "react-query-kit";

import type { IPickSingleQuery } from "../../types";
import { getApi } from "../../apiPath";
import { axiosClient } from "../../clients";

import type { IMemberAcademicDegree } from "./routeType";

const { key, getPath } = getApi("members.academicDegree.get");

type IExtractedRouteType =
  IMemberAcademicDegree["memberAcademicDegreeSingleRetrieve"];

export type IGetMemberAcademicGroup = IPickSingleQuery<IExtractedRouteType>;

const getMemberAcademicGroup: Fetcher<
  IGetMemberAcademicGroup["response"],
  IGetMemberAcademicGroup["variables"]
> = ({ memberId, academicDegreeId, ...params }) => {
  return axiosClient.get(getPath({ memberId, academicDegreeId }), { params });
};

export const useGetMemberAcademicGroup = createQuery({
  queryKey: [key],
  fetcher: getMemberAcademicGroup,
});
